let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("Vmmy2")).then(() => parcelRequire('cc5Qv'));